// @flow

import React, { type Element } from 'react'
import { Typography, Grid, Box, Modal, Link } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import FacilityCreationForm from './FacilityCreationForm'
import type { PrivateFacility } from '../../types'
import { grey } from '@material-ui/core/colors'

type Props = {|
  handleServerErrors: ({ [string]: Array<string> }) => void,
  modalOpen: boolean,
  closeModal: () => void,
  createdFacilities: Array<PrivateFacility>,
  setCreatedFacilities: (any) => void,
  showSuccess: () => void,
|}

function PrivateFacilityCreationModal({
  handleServerErrors,
  modalOpen,
  closeModal,
  createdFacilities,
  setCreatedFacilities,
  showSuccess,
}: Props): Element<typeof React.Fragment> {
  return (
    <Modal open={modalOpen}>
      <Box
        style={{ outline: 0 }}
        borderRadius={8}
        padding={3.5}
        bgcolor="white"
        position="relative"
        width="50%"
        minWidth={400}
        maxWidth={600}
        m="auto"
        top="25%"
      >
        <Grid container direction="row" justify="flex-end" alignItems="center">
          <CloseIcon onClick={closeModal} style={{ cursor: 'pointer' }} />
        </Grid>
        <Grid container>
          <Grid item xs={12}>
            <Box mb={2} fontWeight="fontWeightMedium" color={grey[900]}>
              <Typography variant="h4" color="inherit">
                Add New BCP Facility
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box mb={3}>
              <Typography>
                Please ensure that you’ve enrolled in the Business Cost Premium and MSP has assigned
                you a facility code for your private office.{' '}
                <Link
                  href="https://support.dr-bill.ca/en/articles/5274972-business-cost-premium-bcp"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  Learn more.
                </Link>
              </Typography>
            </Box>
          </Grid>
          <FacilityCreationForm
            handleServerErrors={handleServerErrors}
            createdFacilities={createdFacilities}
            setCreatedFacilities={setCreatedFacilities}
            closeModal={closeModal}
            showSuccess={showSuccess}
          />
        </Grid>
      </Box>
    </Modal>
  )
}

export default PrivateFacilityCreationModal
